import { SelectionBox, SelectionBoxOption } from "@helix/selection-box";
import styled from "styled-components";
import Badge from "../../common/Badge";

export const StyledSelectionBox = styled(SelectionBox)`
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
  margin-bottom: 1.6rem;
  max-height: 30rem;
  overflow-y: auto;
  padding: 0.1rem;

  &::-webkit-scrollbar {
    width: 0.8rem;
    background-color: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background-color: ${({ theme }) => theme.styleGuide.colors.gray[600]};
    border-radius: 0.4rem;
    margin-left: 0.3rem;
  }
`;

export const StyledSelectionBoxOption = styled(SelectionBoxOption)`
  div:first-child {
    display: flex;
    gap: 1.2rem;
  }
`;

export const AccountIcon = styled.div`
  width: 3.6rem;
  height: 3.6rem;
  border-radius: 1.2rem;
  background-color: ${({ theme }) => theme.colors.grayLighterSuper};
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  flex-shrink: 0;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;

export const AccountDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
`;

export const AccountName = styled.div.attrs({
  style: {
    display: "-webkit-box",
    WebkitBoxOrient: "vertical",
    WebkitLineClamp: "2",
    overflow: "hidden"
  }
})`
  font-size: 1.4rem;
  font-weight: 600;
  line-height: 1.8rem;
  max-width: 20.3rem;
  overflow-wrap: anywhere;
`;

export const AccountProvider = styled.div`
  display: flex;
  align-items: center;
  gap: 0.6rem;
  font-size: 1.2rem;
  color: ${({ theme }) => theme.colors.gray};
`;

export const RoleBadge = styled(Badge)`
  min-width: 0;
  padding: 0.2rem 0.6rem;
  font-size: 1.1rem;
  line-height: 1.4rem;
  color: ${({ theme }) => theme.colors.grayDark};
  background-color: ${({ theme }) => theme.colors.grayLighterSuper};
`;

export const AccountActivity = styled.div`
  display: flex;
  align-items: center;
  gap: 0.4rem;
  font-size: 1.1rem;
  color: ${({ theme }) => theme.colors.gray};

  p {
    margin: 0;
  }
`;

export const MultipleAccountsMessage = styled.p`
  font-size: 1.4rem;
  line-height: 2rem;
  margin-bottom: 1.6rem;
  color: ${({ theme }) => theme.colors.grayDark};
  text-align: center;
`;
